import { func_print } from "./func_print"
import { jwtDecode } from "jwt-decode";

export const verify_role = (token: any, string_caminho: string) => {
    try {
        const token_aux: any = jwtDecode(token);

        if (string_caminho !== '/gestaotecnicos' &&
            string_caminho !== '/gestaoBeneficiarios' &&
            string_caminho !== '/suporte' &&
            string_caminho !== '/definicoes' &&
            string_caminho !== '/anexoIItemplate' &&
            string_caminho !== '/anexoIIItemplate'
        ) {
            if (token_aux.roles.includes("agricultor")) {
                return "agricultor"
            } else if (token_aux.roles.includes("tecnico")) {
                return "tecnico"
            } else if (token_aux.roles.includes("admin")) {
                return "admin"
            } else {
                return ''
            }
        } else {
            if (token_aux.roles.includes("admin")) {
                return "admin"
            } else if (token_aux.roles.includes("tecnico")) {
                return "tecnico"
            } else if (token_aux.roles.includes("agricultor")) {
                return "agricultor"
            } else {
                return ''
            }
        }




    } catch (e) {
        func_print('verify_role', e, true)
        return ''


    }

}